import {userService} from "../_services";
import {urlHelper} from "./commons/url.helper";
import {history} from "./history";

/**
 * This is the config that contains the server url, client-id and the client-secret
 * @type {{clientId: string, apiUrl: string, clientSecret: string}}
 */
const config = ({
    apiUrl: process.env.RAZZLE_API_URL, // based on profile
    homePage: process.env.RAZZLE_HOMEPAGE,
    clientId: 'timecloud',
    clientSecret: 'gist',
});

// Preparing for headers Basic Authorization for client-id and client-secret
// TODO : Support server-side as well
let auth64;
if (typeof window !== 'undefined') {
// Preparing for headers Basic Authorization for client-id and client-secret
  auth64 = btoa(config.clientId + ":" + config.clientSecret);
}

/**
 * Helper Accumulator for request
 */
export const requestHelper = {
    getBaseUrl,
    loginHeader,
    prepOAuth,
    prepOAuthRefresh,
    queryHeader,
    authHeader,
    goToHomePage
};

/**
 * This method returns the base URL for the API endpoints
 * @returns {string}
 */
function getBaseUrl() {
    return config.apiUrl;
}

/**
 * This is the header for authorization to receive the access tokens
 * @returns {{Authorization: string, "Content-Type": string}}
 */
function loginHeader() {
    return {
        "Content-Type": "application/x-www-form-urlencoded",
        "Authorization": "Basic " + auth64
    };
}

/**
 * This is the body for authorization to receive the access tokens
 * @param username
 * @param password
 * @returns {URLSearchParams}
 */
function prepOAuth(username, password){
    let data = new URLSearchParams();
    data.append('grant_type', 'password');
    data.append('username', username);
    data.append('password', password);
    return data;
}

/**
 * Body for refreshing the access tokens
 *
 * @param username user name
 * @param refreshToken current refresh token
 * @returns {URLSearchParams} data parameters for refreshing tokens
 */
function prepOAuthRefresh(username, refreshToken){
    let data = new URLSearchParams();
    data.append('grant_type', 'refresh_token');
    data.append('username', username);
    data.append('refresh_token', refreshToken);
    return data;
}

/**
 * This is the header for making intial request for token
 * @returns {{Authorization: string, "Content-Type": string}}
 */
function queryHeader(){
    return {
        "Content-Type": "application/json",
        "Authorization": "Basic " + auth64,
    };
}

/**
 * This is the header for requests with access tokens
 * @returns {{Authorization: string}|{}}
 */
function authHeader() {
    let user = userService.getAuthUser();
    if (user && user.token) {
        return { 'Authorization': 'Bearer ' + user.token };
    } else {
        return {};
    }
}

/**
 * Routes homepage url
 */
function goToHomePage() {
    return (urlHelper.checkUrlDomain(window.location.href).isLocalOrIp)
        ? history.push("/")
        : window.location.replace(config.homePage);
}
